import { config } from 'api';
import fetchAction from 'utils/fetchAction';
import errorHandler from 'lib/utils/errorHandler';

export const FETCH_YOUR_SAVINGS_HUB_REQUEST = 'FETCH_YOUR_SAVINGS_HUB_REQUEST';
export const FETCH_YOUR_SAVINGS_HUB_SUCCESS = 'FETCH_YOUR_SAVINGS_HUB_SUCCESS';
export const FETCH_YOUR_SAVINGS_HUB_ERROR = 'FETCH_YOUR_SAVINGS_HUB_ERROR';
export const RESTORE_STATE = 'RESTORE_STATE';

export const fetchYourSavingsHub = fetchAction({
  actions: [
    FETCH_YOUR_SAVINGS_HUB_REQUEST,
    FETCH_YOUR_SAVINGS_HUB_SUCCESS,
    FETCH_YOUR_SAVINGS_HUB_ERROR,
  ],
  url: `${config.apiBasePath}/your-savings-hub`,
  onSuccess: ({ data, requestParams, actionParams }) => (dispatch) => {
    try {
      dispatch({
        type: FETCH_YOUR_SAVINGS_HUB_SUCCESS,
        data: {
          ...data,
          scribeContent: {
            ...data.scribeContent,
          },
        },
        requestParams,
        actionParams,
      });
    } catch (error) {
      errorHandler(error);
      dispatch({
        type: FETCH_YOUR_SAVINGS_HUB_ERROR,
        error,
      });
    }
  },
});
